import Api from '@/services/Index'

const sendSms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/start', data)
}

const verifySms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/verify', data)
}

const login = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/login', data)
}

const updatePersonalInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/update-personal-information', data)
}

const updateEducationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/update-education-information', data)
}

const updateApplicationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/update-application-information', data)
}

const passwordReminder = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/password-reminder', formData)
}

const downloadFileApplicationSide = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/download-document', formData, {responseType: 'arraybuffer'})
}

/// Admin
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/applications', config)
}

const update = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/applications/'+id, formData,{
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

const downloadFile = async (applicationId, type) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/applications/download-file/'+applicationId+'/'+type, {responseType: 'arraybuffer'})
}

const sendMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/messages', formData)
}

const updateMessage = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/conservatory/application/messages/'+id, formData)
}

const deleteMessage = async (messageId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/conservatory/application/messages/'+messageId)
}

const bulkMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/applications/bulk-message', formData)
}

const getExamList = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('conservatory/application/exam-list', formData)
}

const examInformationExcelExport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/exam-information-excel-export', {responseType: 'arraybuffer'})
}

const importExamInformationExcelImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/exam-information-excel-import', formData)
}

const examResultExcelExport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/exam-result-excel-export', {responseType: 'arraybuffer'})
}

const importExamResultExcelImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/exam-result-excel-import', formData)
}

const calculateExamPoints = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/calculate-exam-points')
}

const getExams = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/exams', config)
}

const updateExam = async (formData, Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/conservatory/application/exams/'+Id, formData)
}

const applicationExcelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/applications/excel-export', {...config, responseType: 'arraybuffer'})
}

const deleteApplication = async (Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/conservatory/applications/'+Id)
}

const applicantPlacement = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/place-students', { responseType: 'arraybuffer'})
}

const makePayment = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/make-payment', formData)
}

const getMernis = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/mernis-data', formData)
}

const searchHighschools = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/high-schools', formData)
}

const approveConsent = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/approve-consent', formData)
}

const examPointExcelExport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/exam-point-excel-export', {responseType: 'arraybuffer'})
}

const importSpecialTalentExcelImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/application/exam-point-excel-import', formData)
}

const calculateSpecialTalentSuccess = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/evaluate-program-results')
}

const excelBulkImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/conservatory/applications/excel-import', formData)
}

const updateExamPoints = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/update-exam-points')
}

const resultPublish = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/publish')
}

const registerApplication = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/register', config)
}

const graduateDateUpdate = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/update-school-graduate-dates')
}

const calculatePlacementPoints = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/conservatory/application/calculate-placement-points')
}

export default {
    sendSms,
    verifySms,
    login,
    updatePersonalInfo,
    updateEducationInfo,
    updateApplicationInfo,
    getAll,
    passwordReminder,
    update,
    downloadFile,
    downloadFileApplicationSide,
    sendMessage,
    updateMessage,
    deleteMessage,
    bulkMessage,
    getExamList,
    examInformationExcelExport,
    importExamInformationExcelImport,
    examResultExcelExport,
    importExamResultExcelImport,
    calculateExamPoints,
    getExams,
    updateExam,
    applicationExcelExport,
    deleteApplication,
    applicantPlacement,
    makePayment,
    getMernis,
    searchHighschools,
    approveConsent,
    examPointExcelExport,
    importSpecialTalentExcelImport,
    calculateSpecialTalentSuccess,
    excelBulkImport,
    updateExamPoints,
    resultPublish,
    registerApplication,
    graduateDateUpdate,
    calculatePlacementPoints
}
